import React, {useEffect, useState} from 'react';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';
import GuestAPI from "@utils/plugins/GuestAPI";

const ReCaptchaWrapper = ({children}) => {
  const [siteKey, setSiteKey] = useState('');

  useEffect(() => {
    GuestAPI.get(`/Captcha`).then((response) => {
      const siteKey = response.data.result;
      setSiteKey(siteKey);
    });
  }, []);

  return (
    siteKey && (
      <GoogleReCaptchaProvider container={{parameters: {badge: 'bottomleft'}}} reCaptchaKey={siteKey} scriptProps={{async: true}}>
        {children}
      </GoogleReCaptchaProvider>
    )
  );
};

export default ReCaptchaWrapper;
